/**
 * メールアドレス形式の共通検証（CRM と判定基準を統一）。
 *
 * CakePHP `Validation::email` のデフォルト正規表現（deep=false 相当）の JS 移植。
 * CRM 側（crmfront/web-ui/src/utils/emailValidation.ts および crmroot の
 * CakePHP `Validation::email`）と同一ルール。**変更時は CRM 側と必ず同期すること。**
 *
 * - ローカル部: Unicode 文字（`\p{L}`）+ 数字 + RFC 許可記号。先頭/末尾/連続ドット不可
 * - ドメイン部: 最低1ドット + 英字2文字以上の TLD 必須。IP アドレス形式は不可
 */
export const EMAIL_PATTERN =
  /^[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,})$/iu;

/** 単一メールアドレスの形式検証（trim はしない。前後の空白は不正扱い） */
export const isValidEmail = (email: string): boolean => EMAIL_PATTERN.test(email);

/**
 * カンマ区切り複数メールアドレスの形式検証。各要素を trim し、空要素は無視する。
 * 空文字・カンマのみは true を返す（必須チェックは呼び出し側の責務）
 */
export const isValidEmailList = (emails: string): boolean =>
  emails
    .split(",")
    .map((email) => email.trim())
    .filter((email) => email)
    .every(isValidEmail);
